module.exports = __webpack_public_path__ + "static/media/valencia-3.de13c906.jpg";